import { useMemo } from "react";

export function useIsConferenceOver() {
    return useMemo(() => (Date.now() > (new Date('2020-06-24T14:00:00.000Z').getTime())), [])
}
